import React from 'react';
import { FaQuoteLeft, FaStar, FaLinkedin } from 'react-icons/fa';
import Section from './layout/Section';
import ScrollReveal from './animations/ScrollReveal';
import SpotlightCard from './effects/SpotlightCard';
import { testimonials, profile } from '../data/profile';

/** Initials stand in until real photos are available. */
const initials = (name) =>
  name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

export default function Testimonials() {
  return (
    <Section
      id="testimonials"
      eyebrow="Kind words"
      title="What people say"
      lead="Notes from people I’ve built products with."
      className="border-y border-slate-200/80 bg-white dark:border-white/[0.06] dark:bg-slate-950/40"
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {testimonials.map((testimonial, index) => (
          <ScrollReveal
            key={`${testimonial.name}-${index}`}
            direction="up"
            delay={index * 0.07}
            className="h-full"
          >
            <SpotlightCard as="figure" className="flex h-full flex-col p-7">
              <FaQuoteLeft className="h-5 w-5 text-blue-500/30" aria-hidden="true" />

              <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-slate-700 dark:text-slate-300">
                {testimonial.quote}
              </blockquote>

              <div
                className="mt-4 flex items-center gap-0.5"
                role="img"
                aria-label={`${testimonial.rating} out of 5`}
              >
                {Array.from({ length: testimonial.rating }).map((_, starIndex) => (
                  <FaStar key={starIndex} className="h-3 w-3 text-amber-400" aria-hidden="true" />
                ))}
              </div>

              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-200/80 pt-6 dark:border-white/[0.06]">
                <span
                  aria-hidden="true"
                  className="flex h-10 w-10 flex-none items-center justify-center rounded-full
                             bg-gradient-to-br from-blue-500/20 to-indigo-500/10 text-[13px] font-semibold
                             text-blue-600 ring-1 ring-inset ring-blue-500/20 dark:text-blue-400"
                >
                  {initials(testimonial.name)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-slate-900 dark:text-white">
                    {testimonial.name}
                  </span>
                  <span className="block text-xs text-slate-500">
                    {testimonial.role}, {testimonial.company}
                  </span>
                </span>
              </figcaption>
            </SpotlightCard>
          </ScrollReveal>
        ))}
      </div>

      <ScrollReveal direction="up" delay={0.1}>
        <p className="mt-10 text-center text-sm text-slate-500 dark:text-slate-400">
          More recommendations on{' '}
          <a
            href={profile.social.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 font-semibold text-blue-600 underline-offset-4
                       hover:underline dark:text-blue-400"
          >
            <FaLinkedin className="h-3.5 w-3.5" aria-hidden="true" />
            LinkedIn
          </a>
        </p>
      </ScrollReveal>
    </Section>
  );
}
